import { Anchor, Stack, Text } from '@mantine/core';

import { CLEAR_FILTERS_TEXT, NO_FILTER_MATCHES_TEXT } from '../constants';

type NoFilterMatchesProps = {
  onClear: () => void;
};

export const NoFilterMatches: React.FC<NoFilterMatchesProps> = ({ onClear }) => (
  <Stack align="center" gap={4} py="xl" px="xs">
    <Text c="black" fw={700} size="sm" ta="center">
      {NO_FILTER_MATCHES_TEXT}
    </Text>
    <Anchor component="button" type="button" size="sm" c="black" onClick={onClear}>
      {CLEAR_FILTERS_TEXT}
    </Anchor>
  </Stack>
);
